module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_vm._m(0), _vm._v(" "), _c('h2', [_vm._v("Hírlevél")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-left": "20px",
      "font-size": "22px",
      "margin-bottom": "20px"
    }
  }, [_c('span', {
    staticStyle: {
      "font-weight": "bold"
    }
  }, [_vm._v("Név:")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.name),
      expression: "name"
    }],
    staticStyle: {
      "width": "500px",
      "max-width": "100%",
      "border-radius": "20px",
      "border-color": "black",
      "outline": "none",
      "padding": "10px"
    },
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.name = $event.target.value
      }
    }
  }), _vm._v(" "), _c('br'), _c('br'), _vm._v(" "), _c('span', {
    staticStyle: {
      "font-weight": "bold"
    }
  }, [_vm._v("Cím:")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.email),
      expression: "email"
    }],
    staticStyle: {
      "width": "500px",
      "max-width": "100%",
      "border-radius": "20px",
      "border-color": "black",
      "outline": "none",
      "padding": "10px"
    },
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.email = $event.target.value
      }
    }
  }), _vm._v(" "), _c('br'), _c('br'), _vm._v(" "), _c('span', [_c('router-link', {
    staticStyle: {
      "color": "#C7212E",
      "cursor": "pointer"
    },
    attrs: {
      "tag": "i",
      "to": "/page/aszf"
    }
  }, [_vm._v("Adatkezelési tájékoztató >>")])], 1), _vm._v(" "), _c('br'), _vm._m(1), _vm._v(" "), _c('br'), _c('br'), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.aszf),
      expression: "aszf"
    }],
    staticStyle: {
      "transform": "scale(1.5)",
      "margin-right": "20px"
    },
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.aszf) ? _vm._i(_vm.aszf, null) > -1 : (_vm.aszf)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.aszf,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.aszf = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.aszf = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.aszf = $$c
        }
      }
    }
  }), _vm._v(" "), _c('span', {
    staticStyle: {
      "font-weight": "bold"
    }
  }, [_vm._v("Az adatkezelési nyilatkozatban foglaltakat elfogadom, hozzájárulok, hogy a Bora Hotel Kft. a megadott személyes adataimat kezelje és rendszeres hírlevelet küldjön részemre.")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('button', {
    staticClass: "my-button",
    staticStyle: {
      "background-image": "url('images/aranysav.jpg')",
      "font-size": "28px",
      "width": "300px"
    },
    on: {
      "click": function($event) {
        _vm.send()
      }
    }
  }, [_vm._v("Feliratkozás")])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h2', {
    staticClass: "text-center"
  }, [_vm._v("Szeretne értesülni heti menükínálatunkról és eseményeinkről?"), _c('br'), _vm._v("\n            Iratkozzon fel hírlevelünkre!")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', [_vm._v("Adatkezelési nyilvántartás száma: "), _c('b', [_vm._v("NAIH-123456789")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-d51ba63a","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/app/main/components/bora/NewsletterSub.vue
// module id = 128
// module chunks = 0 1 2